import React from 'react';
import ReportTemplateItem from '../../../Domain/ReportTemplateItem';
import ColButton from '../../../Elements/ColButton';
import ErrorMessage from '../../../Elements/ErrorMessage';
import LoadingIcon from '../../../Elements/LoadingIcon';
import OverWindow from '../../../Elements/OverWindow';
import ReportTemplateService from '../../../Services/ReportTemplateService';

class RemoveTemplateFilePanel extends React.Component 
{
    static defaultProps = {
        reportItem: new ReportTemplateItem(),
        clickOnCancel: null
    };

    constructor (props) 
    {
        super(props);
        this.state = {
            loading: false,
        };
    }

    onSubmit ()
    {
        this.setState({ loading: true });
        ReportTemplateService.RemoveReportTemplateFile(this.props.reportItem.ReportTemplateId)
            .then(() =>
            {
                this.props.clickOnOk();
            })
            .catch(error => ErrorMessage.SetErrorMessage("RTFP31"));

    }

    render ()
    {
        return (
            <OverWindow
                title="Remove Report Template File"
                clickOnCancel={this.props.clickOnCancel}
                iconName="fa-solid fa-trash-can"
                minWidth="800px"
            >
                <form
                    onSubmit={(e) =>
                    {
                        e.preventDefault();
                        this.onSubmit();
                    }}
                >
                    <div className="">
                        <div className="h6">ReportTemplate: {this.props.reportItem.Name}</div>

                        <div className="6">
                            You are going to remove the following template file:
                        </div>
                        <div className="text-center h6 m-2 p-2 border">
                            {this.props.reportItem.TemplateName}
                        </div>

                        <LoadingIcon loading={this.state.loading} />

                        <div className='buttonfooter' >
                            <div className="container-fluid">
                                <div className="row">
                                    <ColButton text="Cancel" onClick={this.props.clickOnCancel} />
                                    <ColButton
                                        text="Remove Report Template File"
                                        type="submit"
                                        icon={"fa-solid fa-trash-can" + (this.state.loading ? " fa-spin" : "")}
                                        disabled={this.state.loading}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </OverWindow>
        );
    }
}


export default RemoveTemplateFilePanel;
